<template>
  <!-- camera icon -->
  <svg
    v-if="name === 'camera-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6663 9.33337L21.333 16L30.6663 22.6667V9.33337Z"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.6663 6.66669H3.99967C2.52692 6.66669 1.33301 7.86059 1.33301 9.33335V22.6667C1.33301 24.1394 2.52692 25.3334 3.99967 25.3334H18.6663C20.1391 25.3334 21.333 24.1394 21.333 22.6667V9.33335C21.333 7.86059 20.1391 6.66669 18.6663 6.66669Z"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- camera off icon -->
  <svg
    v-else-if="name === 'camera-off-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.213 6.66663H18.6663C19.3736 6.66663 20.0519 6.94758 20.552 7.44767C21.0521 7.94777 21.333 8.62605 21.333 9.33329V13.7866L22.6663 15.12L30.6663 9.33329V22.6666M21.333 21.3333V22.6666C21.333 23.3739 21.0521 24.0521 20.552 24.5522C20.0519 25.0523 19.3736 25.3333 18.6663 25.3333H3.99967C3.29243 25.3333 2.61415 25.0523 2.11406 24.5522C1.61396 24.0521 1.33301 23.3739 1.33301 22.6666V9.33329C1.33301 8.62605 1.61396 7.94777 2.11406 7.44767C2.61415 6.94758 3.29243 6.66663 3.99967 6.66663H6.66634L21.333 21.3333Z"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.33301 1.33331L30.6663 30.6666"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- mic icon -->
  <svg
    v-else-if="name === 'mic-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.835 1.33331C15.7741 1.33331 14.7567 1.75474 14.0065 2.50489C13.2564 3.25503 12.835 4.27245 12.835 5.33331V16C12.835 17.0608 13.2564 18.0783 14.0065 18.8284C14.7567 19.5786 15.7741 20 16.835 20C17.8958 20 18.9132 19.5786 19.6634 18.8284C20.4135 18.0783 20.835 17.0608 20.835 16V5.33331C20.835 4.27245 20.4135 3.25503 19.6634 2.50489C18.9132 1.75474 17.8958 1.33331 16.835 1.33331V1.33331Z"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M26.1686 13.3333V16C26.1686 18.4753 25.1853 20.8493 23.4349 22.5996C21.6846 24.35 19.3106 25.3333 16.8353 25.3333C14.3599 25.3333 11.986 24.35 10.2356 22.5996C8.48528 20.8493 7.50195 18.4753 7.50195 16V13.3333"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.835 25.3333V30.6666"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.502 30.6666H22.1686"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- mic off icon -->
  <svg
    v-else-if="name === 'mic-off-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33301 1.33301L30.6663 30.6663"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 12.4531V5.33313C20.001 4.34117 19.6334 3.38422 18.9685 2.64806C18.3036 1.9119 17.3889 1.44905 16.402 1.34936C15.4151 1.24967 14.4263 1.52025 13.6276 2.10858C12.829 2.69691 12.2774 3.56101 12.08 4.53313M12 11.9998V15.9998C12.0007 16.7904 12.2357 17.5631 12.6752 18.2202C13.1148 18.8774 13.7393 19.3895 14.4697 19.692C15.2002 19.9945 16.0039 20.0737 16.7794 19.9196C17.5549 19.7656 18.2673 19.3852 18.8267 18.8265L12 11.9998Z"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.6663 22.5997C21.3646 23.9282 19.6958 24.8376 17.8737 25.2111C16.0517 25.5847 14.1596 25.4053 12.4403 24.696C10.7209 23.9868 9.25261 22.78 8.22383 21.2305C7.19504 19.6811 6.65266 17.8595 6.66627 15.9997V13.333M25.3329 13.333V15.9997C25.3325 16.5496 25.2834 17.0984 25.1863 17.6397"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 25.333V30.6663"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.666 30.6665H21.3327"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- user icon -->
  <svg
    v-else-if="name === 'user-icon'"
    class="user-icon"
    style="stroke: #222"
    :width="width"
    :height="height"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9865 18.9849V16.9866C16.9865 15.9267 16.5655 14.9101 15.816 14.1606C15.0664 13.4111 14.0499 12.99 12.9899 12.99H4.99664C3.93666 12.99 2.9201 13.4111 2.17059 14.1606C1.42107 14.9101 1 15.9267 1 16.9866V18.9849"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99346 8.99327C11.2007 8.99327 12.9901 7.20392 12.9901 4.99664C12.9901 2.78935 11.2007 1 8.99346 1C6.78618 1 4.99683 2.78935 4.99683 4.99664C4.99683 7.20392 6.78618 8.99327 8.99346 8.99327Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- layout square icon -->
  <svg
    v-else-if="name === 'layout-square-icon'"
    style="stroke: #222"
    class="layout-square-icon"
    :width="width"
    :height="height"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 19V3C15 2.46957 14.7893 1.96086 14.4142 1.58579C14.0391 1.21071 13.5304 1 13 1H9C8.46957 1 7.96086 1.21071 7.58579 1.58579C7.21071 1.96086 7 2.46957 7 3V19"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- dollar sign icon -->
  <svg
    v-else-if="name === 'dollar-sign-icon'"
    style="stroke: #222"
    class="dollar-sign-icon"
    :width="width"
    :height="height"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.90527 1V18.9876"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99379 4.27051H3.86166C3.1027 4.27051 2.37483 4.572 1.83816 5.10867C1.3015 5.64533 1 6.37321 1 7.13217C1 7.89113 1.3015 8.619 1.83816 9.15567C2.37483 9.69233 3.1027 9.99383 3.86166 9.99383H7.94975C8.70871 9.99383 9.43658 10.2953 9.97325 10.832C10.5099 11.3687 10.8114 12.0965 10.8114 12.8555C10.8114 13.6145 10.5099 14.3423 9.97325 14.879C9.43658 15.4157 8.70871 15.7172 7.94975 15.7172H1"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- shield icon -->
  <svg
    v-else-if="name === 'shield-icon'"
    style="stroke: #222"
    class="shield-icon"
    :width="width"
    :height="width"
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.19503 18.9876C8.19503 18.9876 15.3901 15.3901 15.3901 9.99379V3.69814L8.19503 1L1 3.69814V9.99379C1 15.3901 8.19503 18.9876 8.19503 18.9876Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- pencil icon -->
  <svg
    v-else-if="name === 'pencil-icon'"
    style="stroke: #222"
    class="pencil-icon"
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1298 1.8356C16.3947 1.57068 16.7092 1.36054 17.0553 1.21716C17.4015 1.07379 17.7725 1 18.1471 1C18.5217 1 18.8927 1.07379 19.2389 1.21716C19.585 1.36054 19.8995 1.57068 20.1644 1.8356C20.4293 2.10051 20.6395 2.41501 20.7828 2.76114C20.9262 3.10727 21 3.47825 21 3.8529C21 4.22755 20.9262 4.59853 20.7828 4.94466C20.6395 5.29079 20.4293 5.60529 20.1644 5.87021L6.54759 19.487L1 21L2.51298 15.4524L16.1298 1.8356Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- map pin icon -->
  <svg
    v-else-if="name === 'map-pin-icon'"
    style="stroke: #222"
    class="map-pin-icon"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 10C20.25 12.7148 18.7556 15.342 16.924 17.5248C15.1061 19.6913 13.0441 21.3158 12.0961 22.0123C12.035 22.0572 11.965 22.0572 11.9039 22.0123C10.9559 21.3158 8.89388 19.6913 7.07598 17.5248C5.24443 15.342 3.75 12.7148 3.75 10C3.75 7.81196 4.61919 5.71354 6.16637 4.16637C7.71354 2.61919 9.81196 1.75 12 1.75C14.188 1.75 16.2865 2.61919 17.8336 4.16637C19.3808 5.71354 20.25 7.81196 20.25 10Z"
      fill="white"
      stroke-width="1.5"
    />
    <path
      d="M14.25 10C14.25 11.2426 13.2426 12.25 12 12.25C10.7574 12.25 9.75 11.2426 9.75 10C9.75 8.75736 10.7574 7.75 12 7.75C13.2426 7.75 14.25 8.75736 14.25 10Z"
      fill="white"
      stroke-width="1.5"
    />
  </svg>

  <!-- envelope icon -->
  <svg
    v-else-if="name === 'envelope-icon'"
    :width="width"
    :height="height"
    style="stroke: #333; fill: none"
    viewBox="0 0 22 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 1H19C20.1 1 21 1.9 21 3V15C21 16.1 20.1 17 19 17H3C1.9 17 1 16.1 1 15V3C1 1.9 1.9 1 3 1Z"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 3L11 10L1 3"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- telephone icon -->
  <svg
    v-else-if="name === 'telephone-icon'"
    :width="width"
    :height="height"
    style="stroke: #333; fill: none"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9995 13.7278V16.287C18.0004 16.5245 17.9517 16.7597 17.8563 16.9774C17.7609 17.1951 17.6211 17.3905 17.4457 17.5511C17.2702 17.7117 17.0632 17.834 16.8376 17.9101C16.6121 17.9862 16.3732 18.0145 16.1361 17.9931C13.5059 17.7078 10.9794 16.8109 8.75957 15.3742C6.69433 14.0644 4.94337 12.3169 3.63104 10.2558C2.18648 8.03034 1.28751 5.49657 1.00694 2.85976C0.985578 2.62386 1.01367 2.3861 1.08942 2.16163C1.16518 1.93716 1.28693 1.73089 1.44694 1.55596C1.60694 1.38102 1.80169 1.24125 2.01879 1.14555C2.23589 1.04985 2.47057 1.00031 2.7079 1.00008H5.27217C5.68698 0.996008 6.08913 1.14261 6.40366 1.41257C6.71818 1.68252 6.92362 2.05741 6.98168 2.46735C7.08991 3.28635 7.29063 4.09049 7.58001 4.86445C7.69501 5.16978 7.7199 5.50162 7.65173 5.82063C7.58355 6.13965 7.42518 6.43248 7.19537 6.66441L6.10983 7.7478C7.32662 9.88348 9.09844 11.6518 11.2384 12.8662L12.3239 11.7828C12.5563 11.5534 12.8497 11.3954 13.1694 11.3273C13.489 11.2593 13.8215 11.2841 14.1274 11.3989C14.9029 11.6877 15.7087 11.888 16.5293 11.9961C16.9445 12.0545 17.3237 12.2632 17.5948 12.5825C17.8658 12.9018 18.0099 13.3094 17.9995 13.7278Z"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- alert icon -->
  <svg
    v-else-if="name === 'alert-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="#ff4133"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 18.3332C14.6017 18.3332 18.3327 14.6022 18.3327 9.99984C18.3327 5.39746 14.6017 1.6665 9.99935 1.6665C5.39698 1.6665 1.66602 5.39746 1.66602 9.99984C1.66602 14.6022 5.39698 18.3332 9.99935 18.3332Z"
      stroke="#ff4133"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 13.3333V10"
      stroke="#fff"
      stroke-width="2.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 6.6665H10.0083"
      stroke="#fff"
      stroke-width="2.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- monitor icon -->
  <svg
    v-else-if="name === 'monitor-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #f8002d; fill: none"
  >
    <path
      d="M15.4 1.2998H2.6C1.71634 1.2998 1 2.01615 1 2.8998V10.8998C1 11.7835 1.71634 12.4998 2.6 12.4998H15.4C16.2837 12.4998 17 11.7835 17 10.8998V2.8998C17 2.01615 16.2837 1.2998 15.4 1.2998Z"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.80005 15.6997H12.2"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 12.5V15.7"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- circle icon -->
  <svg
    v-else-if="name === 'circle-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #ced4da"
  >
    <circle cx="21" cy="21" r="20" stroke-width="1.5" />
  </svg>

  <!--  check circle icon -->
  <svg
    v-else-if="name === 'check-circle-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #f8002d"
  >
    <circle
      cx="21"
      cy="21"
      r="20"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29 15L18 26L13 21"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- warning icon -->
  <svg
    v-else-if="name === 'warning-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: white"
  >
    <path
      d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
      fill="#CED4DA"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 13.6V10"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10
      6.40002H10.009"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- plus icon -->
  <svg
    id="sc-plus"
    v-else-if="name === 'plus-icon'"
    :width="width"
    :height="height"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 5V19"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="color"
    />
    <path
      d="M5 12H19"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="color"
    />
  </svg>

  <!-- layers icon -->
  <svg
    id="sc-layers"
    v-else-if="name === 'layers-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M12 2L2 7L12 12L22 7L12 2Z"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 17L12 22L22 17"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 12L12 17L22 12"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- repeat icon -->
  <svg
    id="sc-repeat"
    v-else-if="name === 'repeat-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M17 1L21 5L17 9"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 11V9C3 7.93913 3.42143 6.92172 4.17157 6.17157C4.92172 5.42143 5.93913 5 7 5H21"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 23L3 19L7 15"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21 13V15C21 16.0609 20.5786 17.0783 19.8284 17.8284C19.0783 18.5786 18.0609 19 17 19H3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- chevron down -->
  <svg
    id="sc-chevron-down"
    v-else-if="name === 'chevron-down-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M1 1.5L5 5.5L9 1.5"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- chevron up -->
  <svg
    id="sc-chevron-up"
    v-else-if="name === 'chevron-up-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M9 5.5L5 1.5L1 5.5"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- chevron right -->
  <svg
    id="sc-chevron-right"
    v-else-if="name === 'chevron-right-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M1 1L6 5.5L1 10"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- chevron left -->
  <svg
    id="sc-chevron-left"
    v-else-if="name === 'chevron-left-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 7 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M6 10L1 5.5L6 1"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- Cross icon -->
  <svg
    v-else-if="name === 'cross-icon'"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 768 768"
    style="stroke: #141414;"
  >
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="64"
      d="M688.001 79.999l-607.999 607.999"
    />
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="64"
      d="M79.999 79.999l607.999 607.999"
    />
  </svg>

  <!-- medical clipboard icon -->
  <svg
    v-else-if="name === 'medical-clipboard-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 3H11C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5C15 3.89543 14.1046 3 13 3Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 14H14"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 12V16"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- clipboard icon -->
  <svg
    v-else-if="name === 'clipboard-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 3H11C9.89543 3 9 3.89543 9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5C15 3.89543 14.1046 3 13 3Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 12H9.01"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 12H15"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 16H9.01"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13 16H15"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <!-- trash icon -->
  <svg
    v-else-if="name === 'trash-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="stroke: #141414;"
  >
    <path
      d="M1 5.1665H2.77778H17"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.4445 5.16664V3.38886C5.4445 2.91737 5.6318 2.46518 5.9652 2.13178C6.2986 1.79838 6.75078 1.61108 7.22228 1.61108H10.7778C11.2493 1.61108 11.7015 1.79838 12.0349 2.13178C12.3683 2.46518 12.5556 2.91737 12.5556 3.38886V5.16664M15.2223 5.16664V17.6111C15.2223 18.0826 15.035 18.5348 14.7016 18.8682C14.3682 19.2016 13.916 19.3889 13.4445 19.3889H4.55561C4.08411 19.3889 3.63193 19.2016 3.29853 18.8682C2.96513 18.5348 2.77783 18.0826 2.77783 17.6111V5.16664H15.2223Z"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.22217 9.61108V14.9444"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.7778 9.61108V14.9444"
      :stroke="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <svg
    v-else-if="name === 'pin'"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 768 768"
    style="stroke: #141414;"
  >
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="48"
      :stroke="color"
      d="M384 449.786c54.497 0 98.675-44.178 98.675-98.675s-44.178-98.675-98.675-98.675-98.675 44.179-98.675 98.675c0 54.497 44.178 98.675 98.675 98.675z"
    />
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="48"
      :stroke="color"
      d="M570.065 537.167l-139.559 139.559c-12.335 12.321-29.057 19.247-46.488 19.247s-34.158-6.923-46.488-19.247l-139.593-139.559c-36.798-36.798-61.858-83.686-72.013-134.727-10.155-51.045-4.94-103.95 14.976-152.031s53.641-89.176 96.915-118.089c43.267-28.913 94.147-44.345 146.189-44.345s102.916 15.432 146.187 44.345c43.268 28.913 77.001 70.007 96.916 118.089s25.132 100.986 14.975 152.031c-10.155 51.041-35.211 97.929-72.014 134.727v0z"
    />
  </svg>

  <svg
    v-else-if="name === 'send-icon'"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 2L11 13"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22 2L15 22L11 13L2 9L22 2Z"
      :stroke="color"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CustomIcons",
  props: {
    name: { type: String, default: "" },
    width: { type: Number, default: 20 },
    height: { type: Number, default: 20 },
    color: { type: String, default: "white" }
  }
};
</script>
